import { render, staticRenderFns } from "./ChannelOfferList.vue?vue&type=template&id=0c66bae2&scoped=true"
import script from "./ChannelOfferList.vue?vue&type=script&lang=js"
export * from "./ChannelOfferList.vue?vue&type=script&lang=js"
import style0 from "./ChannelOfferList.vue?vue&type=style&index=0&id=0c66bae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66bae2",
  null
  
)

export default component.exports